import { render, staticRenderFns } from "./ManageAuthcode.vue?vue&type=template&id=48a27748&scoped=true&"
import script from "./ManageAuthcode.vue?vue&type=script&lang=js&"
export * from "./ManageAuthcode.vue?vue&type=script&lang=js&"
import style0 from "./ManageAuthcode.vue?vue&type=style&index=0&id=48a27748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a27748",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
